import { Component, inject } from '@angular/core';

import { NgxButtonComponent } from '@digipay/ngx-button';
import { PipesModule } from '@digipay/ng-lib-pipes';
import { IProcessData } from '../../models/process-data.interface';
import { ECollateralPage } from '../../models/collatetral-page.enum';
import { WealthNavigationService } from '@client-monorepo/wealth/navigation';
import { CAMPAIGN_OTP_ROUTE } from '../../../../data-access/constants/app-routes';
import { NgxBottomSheetService } from '@digipay/ngx-bottom-sheet';
import { CollateralService } from '../../services/collateral.service';
import { NgxCheckboxComponent } from '@digipay/ngx-checkbox';

@Component({
  selector: 'wealth-applet-collateral-confirm-info-bottom-sheet',
  standalone: true,
  imports: [NgxButtonComponent, PipesModule, NgxCheckboxComponent],
  templateUrl: './collateral-confirm-info-bottom-sheet.component.html',
  styleUrl: './collateral-confirm-info-bottom-sheet.component.scss',
})
export class CollateralConfirmInfoBottomSheetComponent {
  agreementChecked: boolean;
  isLoading: boolean;
  navigationService = inject(WealthNavigationService);
  data: any;

  private bottomSheet = inject(NgxBottomSheetService);
  private collateralService = inject(CollateralService);

  constructor() {
    this.data = this.bottomSheet.data();
  }

  continue() {
    this.isLoading = true;
    const data: IProcessData = {
      units: this.data.units,
      fullName: this.data.fullName,
    };
    this.collateralService.process(data, this.data.coordinatorAction).subscribe((res) => {
      if (res?.success) {
        switch (res.result.data.pageName) {
          case ECollateralPage.page_global_otp:
            this.close();
            this.navigationService.navigateWithState([CAMPAIGN_OTP_ROUTE], {
              state: {
                countDown: res.result.data.countdownInSeconds,
                coordinatorAction: res.result.data.coordinatorAction,
                data: data,
                symbol: this.data.symbol,
              },
            });
            break;
        }
      }
      this.isLoading = false;
    });
  }

  close() {
    this.bottomSheet.closeBottomSheet();
  }

  onToggleAgreement(event: any) {
    this.agreementChecked = event;
  }
}
